<template>
  <div class="vip-modal" v-if="show">
    <div class="modal-overlay" @click="close"></div>
    <div class="modal-container">
      <div class="modal-header">
        <h3>开通VIP会员</h3>
        <button class="modal-close" @click="close">×</button>
      </div>
      
      <div class="modal-body">
        <div class="vip-benefits">
          <h4>VIP会员特权</h4>
          <ul>
            <li><i class="fas fa-check-circle"></i> 无限次使用匹配模式</li>
            <li><i class="fas fa-check-circle"></i> 优先使用高级AI模型</li>
            <li><i class="fas fa-check-circle"></i> 尊享客户服务支持</li>
            <li><i class="fas fa-check-circle"></i> 更多高级功能</li>
          </ul>
        </div>
        
        <div class="payment-price">
          <div class="price-tag">
            <span class="currency">¥</span>
            <span class="amount">0.1</span>
          </div>
          <div class="price-period">31天VIP会员</div>
        </div>
        
        <div class="payment-method">
          <button 
            class="btn-pay" 
            @click="createPayment" 
            :disabled="isLoading"
          >
            <i class="fab fa-weixin"></i> 
            {{ isLoading ? '正在生成支付码...' : '微信支付' }}
          </button>
        </div>
        
        <!-- QR Code Section -->
        <div v-if="showQRCode" class="qrcode-container">
          <div v-if="paymentLoading" class="qrcode-loading">
            <div class="spinner"></div>
            <span>二维码生成中...</span>
          </div>
          <div v-else-if="paymentError" class="qrcode-error">
            <i class="fas fa-exclamation-circle"></i>
            <p>{{ paymentError }}</p>
            <button class="btn-retry" @click="createPayment">重试</button>
          </div>
          <div v-else class="qrcode-display">
            <!-- Use the QRCode component to display the payment QR code -->
            <div v-if="paymentData" class="qrcode-wrapper">
              <QRCode :value="paymentData.code_url" :size="200" level="H" />
              <p class="payment-title">即答VIP会员-31天</p>
              <p class="payment-price-small">¥0.1</p>
            </div>
            <p class="qrcode-tip">打开微信，扫一扫上方二维码完成支付</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import QRCode from 'qrcode.vue';

export default {
  name: 'VipModal',
  components: {
    QRCode
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      showQRCode: false,
      paymentLoading: false,
      paymentError: null,
      paymentData: null
    };
  },
  methods: {
    close() {
      this.$emit('close');
      // Reset state when modal is closed
      this.showQRCode = false;
      this.paymentError = null;
      this.paymentData = null;
    },
    async createPayment() {
      this.isLoading = true;
      this.paymentLoading = true;
      this.paymentError = null;
      this.showQRCode = true;
      
      try {
        // Call the backend API to create a WeChat payment
        const response = await axios.post('/payment/wechat/create', {}, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        
        if (response.data.success) {
          this.paymentData = response.data;
          console.log('支付二维码链接:', response.data.code_url);
        } else {
          this.paymentError = response.data.message || '创建支付订单失败';
        }
      } catch (error) {
        console.error('支付请求错误:', error);
        this.paymentError = error.response?.data?.message || '创建支付订单失败，请稍后再试';
      } finally {
        this.isLoading = false;
        this.paymentLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.vip-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-container {
  position: relative;
  background-color: var(--card-bg-color, #fff);
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-color, #eee);
}

.modal-header h3 {
  margin: 0;
  color: var(--text-color, #333);
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--text-color, #333);
  cursor: pointer;
}

.modal-body {
  padding: 1.5rem;
}

.vip-benefits {
  margin-bottom: 1.5rem;
}

.vip-benefits h4 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: var(--text-color, #333);
}

.vip-benefits ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.vip-benefits li {
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  color: var(--text-color, #333);
}

.vip-benefits i {
  color: var(--success-color, #28a745);
  margin-right: 0.75rem;
}

.payment-price {
  background-color: var(--light-bg-color, #f8f9fa);
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  margin-bottom: 1.5rem;
}

.price-tag {
  display: flex;
  justify-content: center;
  align-items: baseline;
}

.currency {
  font-size: 1.2rem;
  margin-right: 0.25rem;
  color: var(--primary-color, #4a6cf7);
}

.amount {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--primary-color, #4a6cf7);
}

.price-period {
  margin-top: 0.5rem;
  color: var(--text-color, #555);
}

.payment-method {
  text-align: center;
  margin-bottom: 1.5rem;
}

.btn-pay {
  background-color: #07c160;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
}

.btn-pay i {
  margin-right: 0.5rem;
  font-size: 1.25rem;
}

.btn-pay:hover {
  background-color: #06ad56;
}

.btn-pay:disabled {
  background-color: #7fd4a4;
  cursor: not-allowed;
}

.qrcode-container {
  margin: 1.5rem 0;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.qrcode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: var(--primary-color, #4a6cf7);
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.qrcode-error {
  text-align: center;
  color: var(--danger-color, #dc3545);
}

.qrcode-error i {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.btn-retry {
  background-color: var(--primary-color, #4a6cf7);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  margin-top: 0.5rem;
  cursor: pointer;
}

.qrcode-display {
  text-align: center;
}

.qrcode-wrapper {
  margin: 0 auto;
  padding: 1rem;
  border: 1px solid var(--border-color, #eee);
  background-color: white;
  border-radius: 8px;
}

.payment-title {
  margin: 0.5rem 0 0;
  font-weight: bold;
  color: var(--text-color, #333);
}

.payment-price-small {
  margin: 0.25rem 0 0;
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--primary-color, #4a6cf7);
}

.qrcode-tip {
  margin-top: 1rem;
  color: var(--text-color, #666);
  font-size: 0.9rem;
}

/* Dark mode adjustments */
[data-theme="dark"] .modal-container {
  background-color: var(--dark-card-bg, #343a40);
}

[data-theme="dark"] .modal-header {
  border-color: var(--dark-border-color, #495057);
}

[data-theme="dark"] .payment-price {
  background-color: var(--dark-secondary-bg, #212529);
}

[data-theme="dark"] .qrcode-wrapper {
  background-color: white;
  border-color: var(--dark-border-color, #495057);
}
</style> 